import { Box, BoxProps } from '@mui/material'
import { COLORS } from 'styles/colors'

interface ScrollbarProps extends BoxProps {
	scrollbarColor?: string
}

export const Scrollbar = ({
	children,
	scrollbarColor,
	sx,
	...props
}: ScrollbarProps) => {
	return (
		<Box
			{...props}
			sx={{
				overflowY: 'auto',
				overflowX: 'hidden',
				'&::-webkit-scrollbar': {
					width: 4,
				},
				'&::-webkit-scrollbar-track': {
					backgroundColor: '#DBDBDB',
					borderRadius: 12,
				},
				'&::-webkit-scrollbar-thumb': {
					backgroundColor: scrollbarColor || COLORS.icon,
					borderRadius: 12,
				},
				...sx,
			}}
		>
			{children}
		</Box>
	)
}
